import React, { Fragment, Component } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { Helmet } from 'react-helmet';
// import Slider from 'react-slick';
// import Carousel from 'nuka-carousel';
import { compose } from 'redux';
import { connect } from 'react-redux';

import { getRecommendedArticles } from '@actions/recommended-articles';
import ContentContainer from '@components/ContentContainer/mobile';
import CardScroll from '@components/CardScroll/mobile';
import Spinner from '@components/common/Spinner';
import ArticlesBanner from '@components/ArticlesBanner';
import ArticlesCardMobile from '@components/ArticlesCardMobile';
import ArticlesCardNew from '@components/ArticlesCardNew';

import ElasticFooter from '@components/ElasticFooter';

import s from './home.css';

import './slickcarousel.css';

import _get from 'lodash/get';
import _orderBy from 'lodash/orderBy'
import _truncate from 'lodash/truncate';
import _upperFirst from 'lodash/upperFirst';
import { getHomeArticlesByIdx } from '@actions/home-articles';

import { getNewArticles } from '@actions/new-articles';

// const Theoplayer = getComponent('theoplayer');
class MobileHome extends Component {
  state = {
    datas: [],
    playlists: [],
    latestMatch: []
  };

  async componentDidMount() {
    this.props.fetchRecommendedArticles(
      this.props.runtime.article_category_featured_id
    );

    this.props.fetchHomeArticles(this.props.runtime.article_categories || []);
    this.props.fetchNewArticles();
  }

  render() {
    if (this.props.homeArticles.meta.status === 'loading') {
      return <Spinner />;
    }

    const featuredArticles = this.props.recommendedArticles.data.articles || [];
    const homeArticles = this.props.homeArticles.data || [];
    const newArticles = this.props.newArticles.data || [];

    const { configParams } = this.props

    const podcastList = _get(configParams, 'data.podcast_data.playlists', [])
    const podcastVis = _get(configParams, 'data.podcast_data.visibility', false)
    const podcastTitle = _get(configParams, 'data.podcast_data.title', 'Podcast')
    let latestPodcast = null
    if(podcastVis && podcastList.length > 0) {
      const arr = _orderBy(podcastList, 'publishDate', 'desc')
      latestPodcast = arr[0]
    }

    return (
      <Fragment>
        <Helmet>
          <link
            rel="stylesheet"
            type="text/css"
            charset="UTF-8"
            href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css"
          />
          <link
            rel="stylesheet"
            type="text/css"
            href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css"
          />
        </Helmet>
        <>
          <div style={{ height: '80px', backgroundColor: 'rgb(16, 17, 18)' }} />
          {featuredArticles.length <= 0 ? null : (
            <>
              <CardScroll
                height={'22rem'}
                styleContainer={{ backgroundColor: '#101112' }}
              >
                <div className={s.slider_container}>
                  {featuredArticles.slice(0, 5).map(article => (
                    <div
                      key={article.title}
                      className={s.article_banner_container}
                    >
                      <div className={s.article_banner_item}>
                        <ArticlesBanner
                          id={article.id}
                          title={article.title}
                          imageUrl={article.imageUrl}
                          isMobile
                        />
                      </div>
                    </div>
                  ))}
                </div>
              </CardScroll>
            </>
          )}

        { podcastVis &&
          <div className={s.main_container_margin}>
            <div className={s.header_container}>
              <span>{podcastTitle}</span>
              <a href="/category/podcast">View all</a>
            </div>
            {
              latestPodcast && 
              <div className={s.content_container} dangerouslySetInnerHTML={{__html: latestPodcast.content}}/>
            }
          </div>
        }


          {newArticles.length > 0 && (
            <div>
              <div className={s.title_articles}>Berita Terbaru</div>
              <CardScroll height={250}>
                <div className={s.slider_container}>
                  {newArticles.map(article => (
                    <div
                      key={article.name}
                      className={s.article_banner_container}
                    >
                      <div className={s.article_card_recent}>
                        <ArticlesCardNew
                          id={article.id}
                          title={_truncate(article.title, {
                            length: 60
                          })}
                          imageUrl={article.imageUrl}
                          time={article.createdAt}
                        />
                      </div>
                    </div>
                  ))}
                </div>
              </CardScroll>
            </div>
          )}

          {homeArticles.map(category => {
            const categoryName = _upperFirst(category.data.attributes.title);
            const articles = category.data.attributes.articles;

            return (
              <>
                {articles && articles.length > 0 && (
                  <>
                    <div className={s.title_articles}>{categoryName}</div>
                    <CardScroll height={250}>
                      <div className={s.slider_container}>
                        {articles.map(article => (
                          <div
                            key={article.name}
                            className={s.article_banner_container}
                          >
                            <div className={s.article_card_recent}>
                              <ArticlesCardNew
                                id={article.id}
                                title={_truncate(article.attributes.title, {
                                  length: 60
                                })}
                                imageUrl={article.attributes.imageUrl}
                                time={article.attributes.createdAt}
                              />
                            </div>
                          </div>
                        ))}
                      </div>
                    </CardScroll>
                  </>
                )}
              </>
            );
          })}
        </>

        <ElasticFooter />
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  return { ...state };
};

const mapDispatchToProps = dispatch => ({
  fetchRecommendedArticles: pathName =>
    dispatch(getRecommendedArticles(pathName)),
  fetchNewArticles: () => dispatch(getNewArticles()),
  fetchHomeArticles: articleIds => dispatch(getHomeArticlesByIdx(articleIds))
});

export default compose(
  withStyles(s),
  connect(mapStateToProps, mapDispatchToProps)
)(MobileHome);
